import { render, staticRenderFns } from "./CreateTonalBlock.vue?vue&type=template&id=457e46a1&scoped=true"
import script from "./CreateTonalBlock.vue?vue&type=script&lang=js"
export * from "./CreateTonalBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e46a1",
  null
  
)

export default component.exports